import React from 'react';
import TR from '../../Trans';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

function UpdateDialog(props) {

  const renderUpdateStr = () => {
    if (props.isForceUpdate) {
      return <p>
        {TR.dp_muvika_app_will_be_updated}.
      </p>;
    } else {
      return <p>
        {TR.dp_update_now_question}
      </p>;
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      props.onOkay();
    }
  };

  return (
    <BDialog disableRestoreFocus open={props.open} onKeyDown={handleKeyDown} onClose={props.onClose}>
      <DialogTitle>{TR.cm_software_update}</DialogTitle>
      <DialogContent>
        {renderUpdateStr()}
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="secondary" onClick={props.onClose}>{TR.cm_cancel}</Button>
          <Button color="success" onClick={props.onOkay}>Ok</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default UpdateDialog;